import React, { useEffect, useState } from 'react';
import { compose, graphql, withApollo } from 'react-apollo';

import MenuLinkForm from '../components/form/MenuLink';
import { Redirect } from 'react-router-dom';
import createMenuLink from '../apollo/graphql/menuLink/create';
import deleteMenuLink from '../apollo/graphql/menuLink/delete';
import getMenu from '../apollo/graphql/menu/get';
import getMenuCategories from '../apollo/graphql/menuCategory/getAll';
import getMenuLink from '../apollo/graphql/menuLink/get';
import updateMenuLink from '../apollo/graphql/menuLink/update';

const MENU_TYPE = 'HEADER';

const HeaderLinkContainer = (props) => {
  const isNew =
    props.match.params.objId === 'new' ||
    props.match.params.objId === undefined;
  const [menuLinkState, setMenuLinkState] = useState({
    status: {
      loading: true,
      message: null,
      error: null,
      errors: [],
      isNew: isNew,
      deletion: { confirm: false },
    },
    redirect: false,
    obj: {
      order: 0,
      label: '',
      url: '',
      language_code: 'fr',
      menu_category_id: null,
    },
  });

  const fetchMenuLink = async () => {
    const { data } = await props.client.query({
      query: getMenuLink,
      variables: { id: props.match.params.objId },
    });

    if (getMenuLink.error) {
      setMenuLinkState((prev) => ({
        ...prev,
        status: {
          ...prev.status,
          error: true,
          message: getMenuLink.error.message,
        },
      }));
    }

    setMenuLinkState((prev) => ({
      ...prev,
      status: { ...prev.status, loading: false },
      obj: data.getMenuLink,
    }));
  };

  useEffect(() => {
    props.getMenuCategories.refetch();

    if (!isNew) {
      fetchMenuLink();
    } else {
      setMenuLinkState((prev) => ({
        ...prev,
        status: { ...prev.status, loading: false },
      }));
    }
  }, []);

  const handleChange = (event, data, type) => {
    const newObj = { ...menuLinkState.obj };

    if (type === 'dropdown') {
      if (data.id === 'language_code') {
        newObj.menu_category_id = null;
      }
      newObj[data.id] = data.value;
    } else {
      newObj[event.target.id] = event.target.value;
    }

    setMenuLinkState((prev) => ({
      ...prev,
      obj: newObj,
    }));
  };

  const handleDelete = async (event, data) => {
    event.preventDefault();
    const newStatus = { ...menuLinkState.status };

    switch (data.confirm) {
      case true:
        newStatus.deletion.confirm = true;
        break;
      case null:
        newStatus.deletion.confirm = false;
        break;
      case false:
        newStatus.deletion.confirm = false;
        props
          .deleteMenuLink({
            variables: { id: menuLinkState.obj.id },
          })
          .then(() => {
            setMenuLinkState((prev) => ({ ...prev, redirect: true }));
          })
          .catch((err) => {
            setMenuLinkState((prev) => ({
              ...prev,
              status: {
                ...prev.status,
                loading: false,
                message: err.message,
                error: true,
              },
            }));
          });
        break;
      default:
        break;
    }

    setMenuLinkState((prev) => ({ ...prev, status: newStatus }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setMenuLinkState((prev) => ({
      ...prev,
      status: { ...prev.status, loading: true },
    }));

    const newObj = { ...menuLinkState.obj };

    if (menuLinkState.status.isNew) {
      try {
        const { errors } = await props.createMenuLink({
          variables: {
            input: { ...newObj, menuType: MENU_TYPE },
          },
        });

        if (errors) {
          setMenuLinkState((prev) => ({
            ...prev,
            status: {
              ...prev.status,
              error: true,
              loading: false,
              message: errors[0].message,
              errors: errors,
            },
          }));
        } else {
          setMenuLinkState((prev) => ({ ...prev, redirect: true }));
        }
      } catch (err) {
        setMenuLinkState((prev) => ({
          ...prev,
          status: {
            ...prev.status,
            loading: false,
            message: err.message,
            error: true,
            isNew: true,
          },
        }));
      }
    } else {
      const { id } = newObj;
      delete newObj.id;
      delete newObj.updated_at;

      const { errors } = await props.updateMenuLink({
        variables: { id, input: { ...newObj, menuType: MENU_TYPE } },
      });

      if (errors) {
        setMenuLinkState((prev) => ({
          ...prev,
          status: {
            ...prev.status,
            loading: false,
            message: errors[0].message,
            error: true,
            isNew: true,
          },
        }));
      } else {
        setMenuLinkState((prev) => ({ ...prev, redirect: true }));
      }
    }
  };

  if (menuLinkState.redirect) {
    return <Redirect to="/menu" />;
  }
  if (menuLinkState.status.loading) {
    return <div>Chargement...</div>;
  }
  return (
    <MenuLinkForm
      obj={menuLinkState.obj}
      status={menuLinkState.status}
      categories={props.getMenuCategories}
      onChange={handleChange}
      onSubmit={handleSubmit}
      onDelete={handleDelete}
      isHeaderMenu
    />
  );
};

const HeaderLinkContainerEnhanced = compose(
  graphql(getMenuCategories, { name: 'getMenuCategories' }),
  graphql(updateMenuLink, { name: 'updateMenuLink' }),
  graphql(createMenuLink, { name: 'createMenuLink' }),
  graphql(deleteMenuLink, {
    name: 'deleteMenuLink',
    options: {
      update: (proxy, { data }) => {
        const menu = proxy.readQuery({
          query: getMenu,
          variables: { type: MENU_TYPE },
        });
        menu.getMenu.categoriesDetails = menu.getMenu.categoriesDetails.map(
          (category) => {
            return {
              ...category,
              linksDetails: category.linksDetails.filter(
                (link) => link.id !== data.deleteMenuLink.id,
              ),
            };
          },
        );
        proxy.writeQuery({
          query: getMenu,
          variables: { type: MENU_TYPE },
          data: menu,
        });
      },
    },
  }),
)(HeaderLinkContainer);

export default withApollo(HeaderLinkContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/HeaderLinkContainer.js